import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=19ec5939&scoped=true"
import script from "./NavigationList.vue?vue&type=script&lang=js"
export * from "./NavigationList.vue?vue&type=script&lang=js"
import style0 from "./NavigationList.vue?vue&type=style&index=0&id=19ec5939&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec5939",
  null
  
)

export default component.exports